import { dynamicApiSlice } from "../dynamicApi";
import { buildODataQuery } from "@/helpers";
import type { ODataResponse, WorkflowInstance } from "@/types";

export type WorkflowList = WorkflowInstance[];

export const workflowsListApi = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWorkflows: builder.query<
      WorkflowList,
      {
        filter?: string;
        select?: string[];
        expand?: string;
        orderBy?: string;
        top?: number;
        skip?: number;
      }
    >({
      query: (params) => `WorkflowInstances?${buildODataQuery(params)}`,
      transformResponse: (response: ODataResponse<WorkflowList>) =>
        response.value,
    }),
  }),
  overrideExisting: false,
});

export const { useGetWorkflowsQuery } = workflowsListApi;
